export const DEFAULT_NATION_INFO = {
    attackAmount: 0,
    defenceAmount: 0,
    factoryAmount: 0,
    rewardAmount: 0,
    totalAmount: 0,
    victimVotedCount: 0
}